(function () {
    angular.module('if-else.dir', [])
        .directive('ifElse', ['$rootScope', '$compile', '$templateCache', 'plumbService', 'helpers', 'canvasService', '$timeout', 'CANVAS_OPTS', ifElse]);

    function ifElse($rootScope, $compile, $templateCache, plumbService, helpers, canvasService, $timeout, CANVAS_OPTS) {
        return {
            scope: {},
            controller: ['$scope', function ($scope) {
                // extending translate method, this method not available on isolate scope
                $scope.translate = $rootScope.translate;
                $scope.wasSave = false;

                //When we save a the form
                $scope.save = function (dummy) {
                    //If form data is missing
                    if ($scope.passesConnectionCheck() === false) {
                        $scope.displayError = true;
                        $rootScope.$emit('errorMsg', $rootScope.translate('canvas.error.601'));

                        if($scope.tempConn) {
                            $scope.connections = angular.copy($scope.tempConn);
                        }
                    }
                    //Else we proceed to save and create new elements
                    else {
                        if(!dummy && $scope.connections.isDummy) {
                            delete $scope.connections.isDummy;
                        }

                        Intercom('trackEvent', 'AP Node - Multiple Condition');

                        //Updates the parent to register its children
                        var parentData = helpers.getConnectionById($scope.connections.parent);
                        if (parentData) {
                            parentData.children = [];
                            parentData.children.push($scope.connections.id);
                            helpers.updateConnections(parentData);
                        }
                        //Save to the global canvas object
                        helpers.updateConnections($scope.connections);

                        var index = $rootScope.unsavedData.indexOf($scope.connections.id);
                        if (index > -1) {
                            $rootScope.unsavedData.splice(index, 1);
                        }

                        //Displays th form data
                        $scope.displayList = false;
                        $rootScope.$emit('hideConditionIfElseModal');

                        //Displays action menu
                        $scope.displaySubMenuIf = false;
                        $scope.displayInnerSubMenuIf = [];
                        //Hides Error
                        $scope.displayError = false;

                        $scope.displayConditionMenu = [];
                        $scope.displayConditionConnectors = true;

                        var lastElement = $scope.connections;

                        lastElement.children = [];

                        if ($rootScope.cElement) {
                            delete $rootScope.cElement;
                            $scope.newlyCreate = false;
                            for (var i = 0; i < $rootScope.loaderData.length; i++) {
                                // update label according to language
                                if ($rootScope.loaderData[i].parent === lastElement.id) {
                                    $rootScope.loaderData[i].label = ( $rootScope.loaderData[i].elemName  === 'ifElseMeets') ? $scope.translate('commons.meetsConditions') : $scope.translate('commons.doesNotMeetsConditions');

                                    $scope.rectangleCons.push($rootScope.loaderData[i]);
                                    $scope.setPlumbRectangles(lastElement, $scope.rectangleCons.length - 1);

                                    if($rootScope.loaderData[i].children) {
                                        $scope.hasArrow[$rootScope.loaderData[i].id] = true;
                                        $scope.showConnectionArrow[$rootScope.loaderData[i].id] = false;
                                    }else{
                                        $scope.hasArrow[$rootScope.loaderData[i].id] = false;
                                        $scope.showConnectionArrow[$rootScope.loaderData[i].id] = false;
                                    }

                                    $rootScope.$on('arrowReconnected' + $rootScope.loaderData[i].id, function(evt, id) {
                                        if (id) {
                                            $scope.hasArrow[id] = true;
                                        }
                                    });

                                    $rootScope.$on('hideArrowDelete' + $rootScope.loaderData[i].id, function(evt, id) {
                                        if (id) {
                                            $scope.hasArrow[id] = false;
                                        }
                                    });

                                    $rootScope.$on('showConnectionArrow_' + $rootScope.loaderData[i].id, function (event, condition, id) {
                                        $scope.showConnectionArrow[id] = condition;
                                    });
                                }
                            }
                        } else {
                            // saved for the first time
                            if ($scope.newlyCreate) {
                                $scope.newlyCreate = false;
                                for (var i = 0; i<2; i++) {
                                    var lastTopRectangle;
                                    if (i != 0) {
                                        lastTopRectangle = $scope.rectangleCons[i - 1].top + 200;
                                    }
                                    $scope.createNewConnection(lastElement, i, lastTopRectangle);
                                }
                            }
                        }
                        for (var i = 0; i < $scope.rectangleCons.length; i++) {
                            $scope.rectangleCons[i].dataIndex = i;
                            $scope.displayPlus[i] = true;
                            if(lastElement){
                                if(lastElement.children.indexOf($scope.rectangleCons[i].id) === -1){
                                    lastElement.children.push($scope.rectangleCons[i].id);
                                }
                                helpers.updateConnections(lastElement);
                            }
                            //Save to the global canvas object
                            helpers.updateConnections($scope.rectangleCons[i]);
                        }

                        //Save Journey to template
                        canvasService.saveJourneyStorge('journey', JSON.stringify($rootScope.connections),  $scope.isElegibleForUpdate);

                        if ($scope.isElegibleForUpdate) {
                            $scope.wasSave = true;
                            $timeout(() => {
                                $scope.wasSave = false;
                            }, 1500);
                        }

                        //Set Back to autoSave
                        $scope.isElegibleForUpdate = true;

                        //Remove Activate Error since its being able to save
                        $scope.displayActivateError = false;
                        $scope.displayErrorBlink = false;
                    }
                };

                $scope.calculateLastTop = function(index, rootTop, lastTopRectangle) {
                    if(rootTop && !$rootScope.baseTop) {
                        $rootScope.baseTop = rootTop;
                    }

                    return lastTopRectangle || (rootTop + 45);
                };

                $scope.createNewConnection = function(lastElement, con, lastTopRectangle) {
                    var now = new Date();
                    var nextLeft = (con === 0) ? (lastElement.left + 250) : lastElement.left;
                    var nextTop = $scope.calculateLastTop(con, lastElement.top, lastTopRectangle);
                    var last;
                    var idN;

                    $scope.rectangleCons.push({
                        id: 'element_' + now.getTime() + con,
                        top: nextTop,
                        left: nextLeft,
                        type: 'RectangleConnection',
                        data: {},
                        elemClass: 'rectangle-connector',
                        parent: lastElement.id,
                        color: '#FF7F57',
                        label: (con === 0)? $scope.translate('commons.meetsConditions') : $scope.translate('commons.doesNotMeetsConditions'),
                        elemName: (con === 0)? 'ifElseMeets' : 'ifElseNotMeets'
                    });

                    last = $scope.rectangleCons.length - 1;
                    idN = $scope.rectangleCons[last].id;
                    $scope.hasArrow[idN] = false;
                    $scope.showConnectionArrow[idN] = false;

                    $rootScope.$on('arrowReconnected' + idN, function(evt, id) {
                        if (id) {
                            $scope.hasArrow[id] = true;
                        }
                    });

                    $rootScope.$on('hideArrowDelete' + idN, function(evt, id) {
                        if (id) {
                            $scope.hasArrow[id] = false;
                        }
                    });

                    $rootScope.$on('showConnectionArrow_' + idN, function (event, condition, id) {
                        $scope.showConnectionArrow[id] = condition;
                    });

                    $scope.setPlumbRectangles(lastElement, con);
                };

                //Set up the rectangle connections
                $scope.setPlumbRectangles = function (lastElement, con) {
                    $timeout(function () {
                        plumbService.connectElements(lastElement, $scope.rectangleCons[con]);
                    }, 0);
                };

                $scope.config = function (evt) {
                    var newTop = parseInt($(evt.currentTarget).inlineStyle('top')),
                        newLeft = parseInt($(evt.currentTarget).inlineStyle('left'));

                    // check if being dragged and update position
                    if(newTop !== $scope.connections.top || $scope.connections.left !== newLeft){
                        $scope.displayList = false;
                        //update rootScope position
                        var wasUpdated = helpers.updatePos($scope.connections.id, newTop, newLeft);
                        // To check if the element has been saved or not in the rootScope
                        if(!wasUpdated){
                            $scope.connections.top = newTop;
                            $scope.connections.left = newLeft;
                        }

                        $rootScope.$emit('hideConditionIfElseModal');

                        return false;
                    }
                    //Show form menu
                    if($scope.displayList === false){
                        $scope.displayList = true;
                        $scope.displayConditionMenu = [];
                        $rootScope.$emit('displayConditionIfElseModal', $scope.connections);
                    }else{
                        $scope.displayList = false;
                        $rootScope.$emit('hideConditionIfElseModal');
                    }
                    //Hide Error
                    $scope.displayError = false;
                    $scope.displaySubMenu = false;
                    $scope.displayInnerSubMenuIf = [];
                };

                $scope.showTipModal = () => {
                    // displays tip modal
                    $rootScope.$emit('displayConditionIfElseModal', $scope.connections, true);
                };

                $scope.$on('closeConfigMenus', function() {
                    if($scope.displayConditionMenu){
                        var rectangleMenu = $scope.displayConditionMenu.length > 0;
                    }

                    if ($scope.displayList || $scope.displaySubMenu || rectangleMenu) {
                        $scope.displaySubMenu = false;
                        $scope.displayConditionMenu = [];
                        $scope.contMenuConfigs = 0;
                    }
                });

                $scope.passesConnectionCheck = function () {
                    var conditionsGroup = $scope.connections.data.conditionGroups,
                        res = true;

                    if (conditionsGroup === undefined) {
                        res = false;
                        $rootScope.$emit('errorMsg', $scope.translate('canvas.error.603'));
                    } else {
                        for (var grp = 0; grp<conditionsGroup.length; grp++) {
                            if (conditionsGroup[grp] === undefined) {
                                res = false;
                            }

                            if (conditionsGroup[grp].length === 0) {
                                res = false;
                            }

                            for (var con = 0; con<conditionsGroup[grp].length; con++) {
                                if(conditionsGroup[grp][con].type === 'list') {
                                    if(conditionsGroup[grp][con].selectedOpt.length === 0) {
                                        res = false;
                                        $scope.connections.data.conditionGroups[grp][con].hasError = true;
                                    }
                                }

                                if (conditionsGroup[grp][con].type === 'url' && (conditionsGroup[grp][con].selectedOpt[0] !== 'any-tracked-page') && !conditionsGroup[grp][con].selectedOpt[1]) {
                                    res = false;
                                    $scope.connections.data.conditionGroups[grp][con].hasError = true;
                                }

                                if ((conditionsGroup[grp][con].selectedOpt[0] === '' || conditionsGroup[grp][con].selectedOpt[0] === undefined) && conditionsGroup[grp][con].type !== 'visited') {
                                    res = false;
                                    $scope.connections.data.conditionGroups[grp][con].hasError = true;
                                }
                            }

                        }
                    }

                    if(!res) {
                        var index = $rootScope.unsavedData.indexOf($scope.connections.id);
                        if (index === -1) {
                            $rootScope.unsavedData.push($scope.connections.id);
                        }

                        $rootScope.$emit('inputErrorsConditionIfElse', $scope.connections.data.conditionGroups);
                    }

                    return res;
                };

                $scope.toggleConnectionMenu = function (event) {
                    //No validation needed since when information is filled we remove the plus icon.
                    $rootScope.$emit('errorMsg', $scope.translate('canvas.error.603'));
                    $scope.displayList = true;
                    $rootScope.$emit('displayConditionIfElseModal', $scope.connections);
                };

                $scope.parseDescription = function(desc) {
                    if (!desc){
                        return $scope.translate('commons.enterDetails');
                    }

                    return desc;
                };

                $scope.setLastElem = function(evt) {
                    plumbService.setLastElemClicked($(evt.target).parents('div.shape').attr('id'));
                };

                $scope.toggleConnectionRectangle = function (event, index) {
                    $scope.displayConditionMenu = [];
                    //Show form menu
                    if ($scope.displayConditionMenu[index] === false || !$scope.displayConditionMenu[index]) {
                        $scope.displayConditionMenu[index] = true;
                        $('#' + event.target.parentNode.id).find('.action-conditions').show();
                        $scope.$broadcast('setMenuDefaults');
                    } else {
                        $scope.displayConditionMenu[index] = false;
                    }
                };


                $rootScope.$on('deletedIfElse', function(evt, id) {
                    if(!$scope.hasOwnProperty('connections')){
                        return;
                    }
                    if($scope.connections.id === id) {
                        for (var i = 0; i < $rootScope.connections.length; i++) {
                            for (var j = 0; j < $scope.connections.children.length; j++) {
                                if ($rootScope.connections[i].id === $scope.connections.children[j]) {
                                    plumbService.deleteElements($rootScope.connections[i]);
                                }
                            }
                        }
                    }
                });

                var hideCont = 0;
                $scope.$on('hideSubMenuIf', function() {

                    if ($scope.displaySubMenuIf) {
                        if(hideCont === 0) {
                            hideCont = 1;
                        } else {
                            $scope.displaySubMenuIf = false;
                            $scope.displayInnerSubMenuIf = [];
                            hideCont = 0;
                        }
                    }else {
                        hideCont = 0;
                    }
                });

                $scope.updateRectPos = function(evt) {

                    var newTop = parseInt($(evt.currentTarget).inlineStyle('top')),
                        newLeft = parseInt($(evt.currentTarget).inlineStyle('left')),
                        id = evt.currentTarget.id,
                        con = helpers.getConnectionById(id);

                    // check if being dragged and update position
                    if (newTop !== con.top || con.left !== newLeft) {
                        //update rootScope position
                        helpers.updatePos(id, newTop, newLeft);
                    }
                };

                $scope.setActionsModel = function (group) {
                    var elIndex = $scope.connections.data.conditionGroups[group].length - 1;

                    $scope.$watch('connections.data.conditionGroups[' + group + '][' + elIndex + '].condition', function(andOr) {
                        if(andOr) {
                            for(var i = 0; i<$scope.connections.data.conditionGroups[group].length; i++){
                                $scope.connections.data.conditionGroups[group][i].condition = andOr;
                            }
                        }
                    });

                    var UpdateFlag = false;
                    $scope.$watch('connections.data.conditionGroups[' + group + '][' + elIndex + '].selectedAction', function (newValue, oldValue) {
                        if (newValue !== oldValue && newValue !== undefined) {
                            if((newValue === 'hasOpenedEmail' || newValue === 'hasNotOpenedEmail' || newValue === 'hasClickedALink' || newValue === 'hasNotClickedALink') && !$scope.emailList) {
                                $rootScope.$emit('errorMsg', $scope.translate('canvas.error.606'));
                                UpdateFlag = true;
                                var selectedOpt = $scope.connections.data.conditionGroups[group][elIndex].selectedOpt;
                                //update connection model
                                $scope.connections.data.conditionGroups[group][elIndex] = canvasService.getInitIfElseModel(oldValue);
                                $scope.connections.data.conditionGroups[group][elIndex].selectedOpt = selectedOpt;
                            }
                            else if(!UpdateFlag) {
                                //update connection model
                                $scope.connections.data.conditionGroups[group][elIndex] = canvasService.getInitIfElseModel(newValue);
                                $scope.connections.data.conditionGroups[group][elIndex].selectedOpt = [];
                                $scope.checkList[group][elIndex] = {};
                                $scope.listTitle[group][elIndex] = 'Select Option';
                            }
                            else {
                                UpdateFlag = false;
                            }
                        }
                    });

                    $scope.$watch('connections.data.conditionGroups[' + group + '][' + elIndex + '].selectedOpt', function (val) {
                        if (val) {
                            if (val === 'anyPage') {
                                $scope.connections.data.conditionGroups[group][elIndex].selectedOpt[1] = '';
                                $scope.append[group][elIndex] = false;
                            }
                        }
                    });

                    $scope.$watch('connections.data.conditionGroups[' + group + '][' + elIndex + '].selectedOpt[1]', function (url) {
                        if (url && $scope.connections.data.conditionGroups[group][elIndex].selectedOpt[0] !== 'contains-url' && $scope.connections.data.conditionGroups[group][elIndex].type !== 'link') {
                            if ('http://'.indexOf(url) === 0 || 'https://'.indexOf(url) === 0) {
                                $scope.urlError[group][elIndex] = false;
                                $scope.append[group][elIndex] = false;
                            } else {
                                if ((url.indexOf('http://') !== 0 && url.indexOf('https://') !== 0) && !$scope.append[group][elIndex]) {
                                    $scope.append[group][elIndex] = true;
                                    $scope.connections.data.conditionGroups[group][elIndex].selectedOpt[1] = 'http://' + url;
                                }

                                var reg = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/;
                                if (!reg.test(url)) {
                                    $scope.urlError[group][elIndex] = true;
                                }
                                else {
                                    $scope.urlError[group][elIndex] = false;
                                }
                            }
                        }
                    });
                };

                $rootScope.$on('emailDeleted', function(evt, Id) {
                    if (Id) {
                        if ($scope.connections && $scope.connections.data) {
                            $scope.emailList = helpers.jbContainsSendEmail();

                            for (var i = 0; i < $scope.connections.data.conditionGroups.length; i++) {
                                for (var j = 0; j < $scope.connections.data.conditionGroups[i].length; j++) {
                                    if ($scope.connections.data.conditionGroups[i][j].selectedOpt[0] === Id) {
                                        $scope.connections.data.conditionGroups[i][j].selectedOpt[0] = '';
                                        $scope.save();
                                        $scope.displayList = true;
                                        $rootScope.$emit('displayConditionIfElseModal', $scope.connections);
                                        helpers.updateConnections($scope.connections);
                                        canvasService.saveJourneyStorge('journey', JSON.stringify($rootScope.connections), true);
                                    }
                                }
                            }
                        }
                    }
                });

                $rootScope.$on('emailUpdated', function(evt, Id) {
                    if(Id) {
                        $scope.emailList = helpers.jbContainsSendEmail();
                    }
                });
            }],
            link: function (scope, elem, attr) {
                //Scope data initialization
                scope.newlyCreate = true;
                scope.displayList = true;
                scope.displayError = false;
                scope.displaySubMenuIf = false;
                scope.selectedAction = {};
                scope.ConnectionsFromLoader = false;
                scope.displayPlus = [];
                scope.rectangleCons = [];
                scope.isElegibleForUpdate = true;
                scope.hideWhenLimit = true;
                scope.modalWindow =  [];
                scope.hideForLimitCon = [];
                scope.displayInnerSubMenuIf = [];
                scope.checkList = [];
                scope.listTitle = [];
                scope.append = [];
                scope.urlError = [];
                scope.emailList = helpers.jbContainsSendEmail();
                scope.hasArrow = {};
                scope.showConnectionArrow = {};


                if(!scope.contactListData) {
                    scope.contactListData = $rootScope.contactListData;
                }

                // load existing
                if ($rootScope.cElement) {
                    // bullet proving multiple targets
                    if (scope.connections){
                        if(document.getElementById(scope.connections.id)) {
                            delete $rootScope.cElement;
                            return false;
                        }
                    }

                    scope.connections = $rootScope.cElement;
                    scope.isElegibleForUpdate = false;

                    if(scope.connections.data.conditionGroups) {
                        for(var i = 0; i<scope.connections.data.conditionGroups.length; i++) {
                            scope.setActionsModel(i);

                            scope.checkList[i] = [];
                            scope.listTitle[i] = [];
                            scope.modalWindow[i] = [];
                            scope.append[i] = [];
                            scope.urlError[i] = [];
                            if(scope.connections.data.conditionGroups[i].length >= 5) {
                                scope.hideForLimitCon[i] = true;
                            }
                            for(var j=0; j<scope.connections.data.conditionGroups[i].length; j++){
                                if(scope.connections.data.conditionGroups[i][j].type === 'list') {
                                    var key = scope.connections.data.conditionGroups[i][j].selectedOpt[0],
                                        val = helpers.getContactListItem(key, scope.contactListData);

                                    scope.checkList[i][j] = {};
                                    scope.checkList[i][j][key] = true;
                                    scope.listTitle[i][j] = val.substring(0,26) + '...';
                                }
                            }
                        }
                    }

                    var template = $templateCache.get('conditions/options/if-else');

                    //Create template and compile it
                    var content = $compile(template)(scope);
                    $('.canvas').append(content);

                    $rootScope.$on('activateErr_' + scope.connections.id, function(evt, display) {
                        scope.displayActivateError = display;
                        scope.displayErrorBlink = false;
                    });

                    $rootScope.$on('emptyErr_' + scope.connections.id, function(evt, display) {
                        scope.displayErrorBlink = display;
                        scope.displayActivateError = false;
                    });

                    $rootScope.$on('saveConditionIfElse' + scope.connections.id, function(evt, conn) {
                        scope.tempConn = angular.copy(scope.connections);
                        scope.connections = angular.copy(conn);
                        scope.save();
                    });

                    scope.save(true);
                }

                $(elem).click(function (evt) {
                    scope.newlyCreate = true;
                    scope.displayError = false;
                    scope.displaySubMenuIf = false;
                    scope.selectedAction = {};
                    scope.ConnectionsFromLoader = false;
                    scope.displayPlus = [];
                    scope.rectangleCons = [];
                    scope.isElegibleForUpdate = true;
                    scope.hideWhenLimit = true;
                    scope.modalWindow =  [];
                    scope.hideForLimitCon = [];
                    scope.displayInnerSubMenuIf = [];
                    scope.checkList = [];
                    scope.listTitle = [];
                    scope.append = [];
                    scope.urlError = [];
                    scope.emailList = helpers.jbContainsSendEmail();
                    scope.hasArrow = {};
                    scope.showConnectionArrow = {};

                    if(!scope.contactListData) {
                        scope.contactListData = $rootScope.contactListData;
                    }

                    $rootScope.activePlus = false;

                    //Load Template
                    var template = $templateCache.get('conditions/options/if-else'),
                        now = new Date(),
                        lastElemId = plumbService.getLastElemClicked(),
                        lastElement = helpers.getConnectionById(lastElemId);

                    //Start Connection obj
                    scope.connections = {
                        id: 'element_' + now.getTime(),
                        top: (lastElement.type == 'RectangleConnection') ? (lastElement.top - 43) : lastElement.top,
                        left: lastElement.left + 250,
                        type: 'Condition',
                        data: {},
                        elemClass: attr.$attr,
                        elemName: 'IfElse',
                        parent: lastElement.id,
                        //Triger: #4F4FC9 // Action: #B21877 // Condition: #FF7F57
                        color: '#FF7F57'
                    };

                    scope.connections.data.additionals = {};
                    scope.connections.data.additionals.initialCondition = true;
                    scope.connections.data.additionals.showForNewGroup = [];
                    scope.connections.data.selectedGroupConditions = [];

                    //Create template and compile it
                    scope.$apply(function () {
                        var content = $compile(template)(scope);
                        $(elem).parents('.canvas').append(content);
                    });

                    // keep track of what has been saved, for activation
                    $rootScope.unsavedData.push(scope.connections.id);

                    $rootScope.$on('activateErr_' + scope.connections.id, function(evt, display) {
                        scope.displayActivateError = display;
                        scope.displayErrorBlink = false;
                    });

                    $rootScope.$on('emptyErr_' + scope.connections.id, function(evt, display) {
                        scope.displayErrorBlink = display;
                        scope.displayActivateError = false;
                    });

                    $rootScope.$on('saveUnsavedData' + scope.connections.id, function() {
                        scope.isElegibleForUpdate = false;
                        scope.save();
                        scope.isElegibleForUpdate = true;
                        if(scope.displayError) {
                            $timeout(function() {
                                scope.displayList = true;
                                $rootScope.$emit('displayConditionIfElseModal', scope.connections);
                            }, 250)
                        }
                    });

                    $rootScope.$emit('displayConditionIfElseModal', scope.connections);

                    $rootScope.$on('saveConditionIfElse' + scope.connections.id, function(evt, conn) {
                        scope.tempConn = angular.copy(scope.connections);
                        scope.connections = angular.copy(conn);
                        scope.save();
                    });

                    // Listener when user cancel the if/else node
                    $rootScope.$on('deleteIfElseNode' + scope.connections.id, function () {
                        scope.deleteElement();
                    });

                    //Hide hide menus
                    $rootScope.$emit('closeMenus', true);
                    scope.displayList = true;

                    plumbService.connectElements(lastElement, scope.connections);
                });

                scope.deleteElement = function() {
                    scope.rectangleCons = [];
                    scope.displayActivateError = false;
                    scope.displayErrorBlink = false;

                    var idx = $rootScope.unsavedData.indexOf(scope.connections.id);

                    if (idx > -1) {
                        $rootScope.unsavedData.splice(idx, 1);
                    }

                    plumbService.deleteElements(scope.connections);

                    if ($rootScope.conn && $rootScope.conn.length === 1 && $rootScope.conn[0].type === 'Entry' ) {
                        $rootScope.activePlus = true;
                    }else {
                        $rootScope.activePlus = false;
                    }
                };

                scope.deleteArrow = function(rectangle) {
                    if(rectangle.hasOwnProperty('children')) {
                        scope.hasArrow[rectangle.id] = false;
                        scope.showConnectionArrow[rectangle.id] = false;
                        plumbService.deleteArrows(rectangle);
                    }
                };
            }
        };
    }
}());




// WEBPACK FOOTER //
// ./app/directives/canvas_directives/if-else.js